import { HostName, hostNameMap } from '../state/interfaces'
import { isTheDomainAWhitelabel } from '../whitelabels/whitelabel-domains'

let consentLogoInserted = false

const addLogoToCookieYesBanner = () => {
  const ckyTitles = document.querySelectorAll('.cky-title')

  if (ckyTitles.length > 0) {
    const divLogoConsentBar = document.createElement('div')
    divLogoConsentBar.className = 'cky-custom-brand-logo-wrapper'
    divLogoConsentBar.setAttribute('data-cky-tag', 'brand-logo')

    const imgElement = document.createElement('img')
    imgElement.src = hostNameMap[HostName.PLANHUB_CONSENT]
    imgElement.alt = 'Brand logo'
    imgElement.className = 'cky-custom-brand-logo'
    imgElement.style.filter = 'brightness(0.5) grayscale(1)'
    divLogoConsentBar.appendChild(imgElement)
    ckyTitles[0].appendChild(divLogoConsentBar)
  }
}

const watchForCookieYesBanner = () => {
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        if (!consentLogoInserted) {
          if (document.querySelector('.cky-title')) {
            observer.disconnect()
            consentLogoInserted = true
            addLogoToCookieYesBanner()
          }
        }
      }
    }
  })
  observer.observe(document, { childList: true, subtree: true })
}

export const insertLogoInConsentIfWhitelabel = () => {
  if (isTheDomainAWhitelabel(window.location.hostname)) {
    watchForCookieYesBanner()
  }
}
